/* Copyright (c) 2017 Backpack Health LLC */

import { types as listActionTypes } from 'redux/actions/lists';

const initialState = {
  isFetching: false,
  collection: [],
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case listActionTypes.LIST_RESIDENCE_COUNTRY_REQUEST:
    case listActionTypes.LIST_RESIDENCE_COUNTRY_RECEIVE:
      return _.assign({}, state, action.payload);
    default:
      return state;
  }
}

export const getResidenceCountries = state => state.lists.residenceCountry.collection;
